import { render, staticRenderFns } from "./ReconciledOwnersList.vue?vue&type=template&id=6287ec25&scoped=true&"
import script from "./ReconciledOwnersList.vue?vue&type=script&lang=js&"
export * from "./ReconciledOwnersList.vue?vue&type=script&lang=js&"
import style0 from "./ReconciledOwnersList.vue?vue&type=style&index=0&id=6287ec25&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6287ec25",
  null
  
)

export default component.exports